import { useSignups } from 'Signups/state';

export default function useShowPayNowArea() {
  const [state] = useSignups();

  const { paymentAmountNeeded, expandedItemID } = state;
  const signupIsArchived = state.currentSignupList?.signupListStatusID === 4;

  const showPayNowArea =
    Number(paymentAmountNeeded) > 0 && !expandedItemID && !signupIsArchived;
  
  return { showPayNowArea }
}